"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M6.7 6.65v9.8h9.7v-9.8H6.7zm0-1h9.7V4.434c0-.482-.538-.934-1.234-.934H7.934c-.696 0-1.234.452-1.234.934V5.65zm0 11.8v1.616c0 .482.538.934 1.234.934h7.232c.696 0 1.234-.452 1.234-.934V17.45H6.7zM15.166 21H7.934C6.72 21 5.7 20.142 5.7 19.066V4.434C5.7 3.358 6.72 2.5 7.934 2.5h7.232c1.214 0 2.234.858 2.234 1.934v14.632c0 1.076-1.02 1.934-2.234 1.934zM12.06 4.85a.5.5 0 1 1 0-1h1.91a.5.5 0 0 1 0 1h-1.91zm-2.579-1a.5.5 0 0 1 0 1h-.36a.5.5 0 0 1 0-1h.36zm3.02 14.9a.95.95 0 1 1-1.9 0 .95.95 0 0 1 1.9 0z';